import React, { useState } from 'react';
import CopyToClipboard from './CopyToClipboard';
import Tooltip from './Tooltip';

const CopyTextWithTooltip = ({
  text,
  tooltipText: initialTooltipText = 'Copy',
  tooltipTextOnCopy = 'Copied!',
  children,
}) => {
  const [tooltipText, setTooltipText] = useState(initialTooltipText);
  const [isOpen, setIsOpen] = useState(undefined);

  return (
    <Tooltip label={tooltipText} open={isOpen} triggerClassName="inline-block w-full max-w-full">
      <CopyToClipboard
        text={text}
        onCopy={() => {
          setTooltipText(tooltipTextOnCopy);
          setIsOpen(true);

          window.setTimeout(() => {
            setTooltipText(initialTooltipText);
            setIsOpen(undefined);
          }, 500);
        }}
      >
        {children}
      </CopyToClipboard>
    </Tooltip>
  );
};

export default CopyTextWithTooltip;
